import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";

import "./styles.scss";
import BannersContainer from "../Banner/BannersContainer";

export default function Layout({ children, header }) {
  return (
    <Container
      fluid
      className="mydpd-layout bg-light d-flex flex-column vh-100 p-0"
      style={{ maxHeight: "100vh" }}
    >
      <BannersContainer />
      <Row className="mydpd-header m-0 sticky-top">
        <Col className="p-0">{header}</Col>
      </Row>
      <Row
        id="myDpdMainContainer"
        className="mydpd-main-container m-0 d-flex flex-column flex-grow-1 overflow-auto"
      >
        <Col className="h-100 p-0">{children}</Col>
      </Row>
    </Container>
  );
}
Layout.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
};
